/**
 * Лёгкая шина событий «структура пространств изменилась».
 *
 * Приложение не использует React Query — список пространств и их
 * представлений грузится вручную в нескольких местах (рельс `AppLayout`,
 * главная `SpacesHomePage`). После мутаций (создание/архивация/удаление
 * пространства, создание/удаление представления) эти места не знали друг о
 * друге, и левый рельс оставался несвежим до перезагрузки страницы.
 *
 * Шина закрывает разрыв минимально: мутирующие компоненты вызывают
 * `emitSpacesChanged()`, а слушатели (рельс) перезагружают свои данные.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

/** Сообщить всем подписчикам, что список пространств/представлений изменился. */
export function emitSpacesChanged(): void {
  for (const listener of listeners) {
    try {
      listener();
    } catch {
      /* подписчик не должен ронять остальных */
    }
  }
}

/** Подписаться на изменения. Возвращает функцию отписки. */
export function onSpacesChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
